import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as RelatorioActions } from '../ducks/relatorio';

import { RelatoriosAPI, listasAPI } from '../../services/api';

import { WarningToast } from '../../components/molecules/Toast';

const { REACT_APP_BASEURL } = process.env;

export function* postRelatorioBeneficiario(action) {
  const { params } = action;
  try {
    const response = yield call(
      listasAPI.post,
      `/gerar-relatorio-beneficiarios-pela-api-de-integracao`,
      params
    );
    const { status } = response;
    if (status === 200) {
      yield put(
        RelatorioActions.postRelatorioBeneficiarioResponse(
          true,
          response.data,
          null
        )
      );
    }
  } catch (error) {
    toast.error(<WarningToast size="30">{error.response.data}</WarningToast>);
  }
}
export function* postRelatorioNestle(action) {
  const { sendEmail } = action;
  try {
    const response = yield call(
      RelatoriosAPI.post,
      `/relatorio-beneficiario-nestle`,
      { sendEmail }
    );
    const { status } = response;
    if (status === 204) {
      yield put(RelatorioActions.postRelatorioNestleResponse(true, {}, null));
      yield put(RelatorioActions.getUltimoRelatorioNestleRequest());
      return;
    }

    throw new Error('Não foi possivel requerir o relatório.');
  } catch (error) {
    if (error?.message || error?.response?.data?.errors?.Messages[0]) {
      toast.success(
        <WarningToast size="30">
          {error?.response?.data?.errors?.Messages[0] || error?.message}
        </WarningToast>
      );
    }
    yield put(RelatorioActions.postRelatorioNestleResponse(false, null, error));
  }
}

export function* getUltimoRelatorioNestle() {
  try {
    const response = yield call(
      RelatoriosAPI.get,
      `/ultimo-relatorio-beneficiario-nestle`
    );

    const { data, success } = response.data;
    if (success) {
      yield put(
        RelatorioActions.getUltimoRelatorioNestleResponse(success, data, null)
      );
      return;
    }

    throw new Error('Não foi possivel listar o relatório.');
  } catch (error) {
    if (error?.message || error?.response?.data?.errors?.Messages[0]) {
      toast.success(
        <WarningToast size="30">
          {error?.response?.data?.errors?.Messages[0] || error?.message}
        </WarningToast>
      );
    }
    yield put(
      RelatorioActions.getUltimoRelatorioNestleResponse(false, null, error)
    );
  }
}
